import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { canonicalLink, metaDescription } from 'utils/seoUtils';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { loadTeam } from '../reducers/team';
import { loadCompetition } from '../reducers/competition';
import { load as loadCompetitions } from '../reducers/competitions';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import FootballLiveDatesList from '../components/FootballLiveDatesList';
import Dropdown from 'modules/Common/components/Dropdown';
import { getPropertyFromRoutes } from 'utils/routeUtils';
import { getTeamsNavList, getCompetitionsNavList } from 'modules/Football/utils';

import { COMPETITIONS_REFRESH_INTERVAL_MILLIS } from 'modules/Football/consts';

require('./FootballFixturesResults.scss');

@layoutAsyncConnect(
  'FootballFixturesResults',
  [
    {
      dispatch: ({params: {teamId}, routes}) => {
        const fixturesResults = getPropertyFromRoutes(routes, 'fixturesResults');

        return loadTeam(teamId, fixturesResults);
      },
      refreshInterval: COMPETITIONS_REFRESH_INTERVAL_MILLIS,
      state: state => ({team: state.football.team.teamData })
    },
    {
      dispatch: () => loadCompetitions(),
      state: state => ({competitions: state.football.competitions.list })
    },
    {
      dispatch: ({params: {compId}}) => loadCompetition(compId),
      state: state => ({selectedCompetition: state.football.competition.selectedCompetition })
    },
    userServiceLayoutConnect()
  ]
)
@catchLifeCycleErrors
export default class FootballFixturesResults extends Component {
  static propTypes = {
    team: PropTypes.object.isRequired,
    competitions: PropTypes.array.isRequired,
    params: PropTypes.object,
    routes: PropTypes.array.isRequired,
    fixturesResults: PropTypes.string.isRequired,
    selectedCompetition: PropTypes.object.isRequired
  }

  render() {
    const {
      team: {
        team: {
          name: teamName
        },
        matches: matchList = []
      },
      selectedCompetition: {
        name: selectedCompetitionName,
        competition_reference: {
          id: competitionId
        },
        show_teams_dropdown: showTeams = true,
        teams: competitionTeams
      },
      competitions = [],
      params = {},
      routes,
      fixturesResults
    } = this.props;

    let title;

    if (fixturesResults == "results") {
      title = `Results`
    }
    else {
      title = `Fixtures`
    }

    const helmetProps = {
      title,
      ...canonicalLink(routes, params),
      ...metaDescription(`Latest ${fixturesResults} for ${teamName}}`)
    };

    return (
      <div className="footballFixturesResults">
        <MetaDataWrapper helmetProps={helmetProps}/>
        <header>
          <Dropdown shouldNavigate={true} title={selectedCompetitionName || 'COMPETITIONS'} options={getCompetitionsNavList(competitions, fixturesResults)} className="competitions-dropdown" noOptionsMessage="No competitions found"/>
          {showTeams && <Dropdown shouldNavigate={true} title={teamName || 'TEAMS'} options={getTeamsNavList(competitionTeams, fixturesResults, selectedCompetitionName, competitionId)} className="teams-dropdown" noOptionsMessage="No teams found"/>}
          <h1>{title}</h1>
        </header>
        <FootballLiveDatesList matchList={matchList} fixturesResults={fixturesResults} showCompetitions/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballTeamFixturesResults.js